import request from "@/shared/api/request";

import type {
  CreateEducationApplicationRequest,
  EducationApplicationResult,
  EducationApplicationsResponse,
  EducationUploadAuthorization,
} from "./types";

export function listEducationApplications(page: number, limit = 10): Promise<EducationApplicationsResponse> {
  return request.get("/api/v1/education/applications", { page, limit });
}

export function authorizeEducationUpload(): Promise<EducationUploadAuthorization> {
  return request.post("/api/v1/education/upload-authorizations", {});
}

export function createEducationApplication(data: CreateEducationApplicationRequest): Promise<EducationApplicationResult> {
  return request.post("/api/v1/education/applications", data);
}

export async function uploadEducationMaterial(
  authorization: EducationUploadAuthorization,
  file: File,
): Promise<string> {
  const extension = file.name.match(/\.[a-zA-Z0-9]{1,12}$/)?.[0]?.toLowerCase() ?? "";
  const key = `${authorization.object_prefix}${crypto.randomUUID()}${extension}`;
  const fields = authorization.post_fields;
  const form = new FormData();
  form.append("policy", fields.policy);
  form.append("x-oss-signature-version", fields.signature_version);
  form.append("x-oss-credential", fields.credential);
  form.append("x-oss-date", fields.date);
  form.append("x-oss-signature", fields.signature);
  form.append("x-oss-forbid-overwrite", fields.forbid_overwrite);
  form.append("x-oss-object-acl", fields.object_acl);
  form.append("success_action_status", fields.success_action_status);
  form.append("key", key);
  form.append("file", file);

  const response = await fetch(authorization.post_url, { method: "POST", body: form });
  if (!response.ok) {
    throw new Error(`证明材料上传失败（${response.status}），请重试。`);
  }

  return `${authorization.object_base_url}${key.split("/").map(encodeURIComponent).join("/")}`;
}
